import downCircleIcon from '@/assets/icons/UI/DownCircle.svg?raw'

export const tableConfig = () => {
  return {
    headerCell: {
      padding: '14px 20px'
    },

    bodyCell: {
      padding: '1.4rem 1.5rem'
    },

    colorScheme: {
      dark: {
        headerCellBackground: 'var(--element-surface-dark)',
        rowBackground: 'var(--form-element-background)'
      },

      light: {
        headerCellBackground: 'var(--secondary-400)',
        rowBackground: 'var(--secondary-100)'
      }
    }
  }
}

export const tablePt = () => {
  return {
    thead: {
      class: 'font-14-b'
    },
    tbody: {
      class: 'font-12-n'
    },
    pcPaginator: {
      pcRowPerPageDropdown: {
        root: {
          class: 'table-paginator-select'
        },

        dropdown: {
          innerHTML: downCircleIcon
        }
      }
    }
  }
}
